import { useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Axios = (props) => {
  let toastId = null;
  let history = useHistory();

  const logoutUser = (error) => {
    if (error && error.response && error.response.status === 403) {
      history.push("/logout");
    }
  };

  const setUpAxiosDefaults = () => {
    axios.defaults.withCredentials = true;
    axios.interceptors.response.use(
      (response) => {
        if (response && response.data && response.data.info) {
          if (!toast.isActive(toastId)) {
            toast.dismiss();
            toast.info(response.data.info, {
              autoClose: 5000,
            });
          }
        }
        if (response && response.data && response.data.msg) {
          if (!toast.isActive(toastId)) {
            toast.dismiss();
            toast.error(response.data.msg, {
              autoClose: 5000,
            });
          }
        }
        return response;
      },
      (error) => {
        // Do something with response error
        if (error && error.response && error.response.status) {
          if (error.response.data && error.response.data.msg) {
            if (!toast.isActive(toastId)) {
              toast.dismiss();
              toast.error(error.response.data.msg, {
                autoClose: 5000,
              });
            }
          } else if (error.response.status === 401) {
            if (!toast.isActive(toastId)) {
              toast.dismiss();
              toastId = toast.error("Incorrect username or password.", {
                autoClose: 5000,
              });
            }
            return Promise.reject(error);
          } else if (error.response.status === 403) {
            if (!toast.isActive(toastId)) {
              toast.dismiss();
              toastId = toast.error("Please log in.", {
                autoClose: 5000,
              });
            }
            logoutUser(error);
            return Promise.reject(error);
          } else {
            if (!toast.isActive(toastId)) {
              toast.dismiss();
              toastId = toast.error("Server Error", {
                autoClose: 5000,
              });
            }
            return Promise.reject(error);
          }
        } else if (error && error.response && !error.response.status) {
          logoutUser(error);
          if (!toast.isActive(toastId)) {
            toast.dismiss();
            toastId = toast.error("Please log in again.", {
              autoClose: 5000,
            });
          }
          return Promise.reject(error);
        }
      }
    );
  };

  useEffect(() => {
    setUpAxiosDefaults(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default Axios;
